import { deserialize, serializable } from 'serializr';
import { Base } from './base.model';
import { Deserializable } from './deserializable';

export class Browser extends Base implements Deserializable {
  @serializable
  public name: string;
  @serializable
  public version: string;
  @serializable
  public majorVersion: string;
  @serializable
  public arch: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(Browser, input));
  }

  get isChrome() {
    return (
      this.name.toUpperCase() == 'GOOGLECHROME' ||
      this.name.toUpperCase() == 'CHROME'
    );
  }

  get isChromeForTesting() {
    return this.name.toUpperCase() == 'CHROMEFORTESTING';
  }

  get isFirefox() {
    return this.name.toUpperCase() == 'FIREFOX';
  }

  get isSafari() {
    return this.name.toUpperCase() == 'SAFARI';
  }

  get isEdge() {
    return this.name.toUpperCase() == 'EDGE';
  }

  get isIE() {
    return this.name.toUpperCase() == 'INTERNETEXPLORER';
  }
}
